import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel,
  TextField, Typography
} from "@mui/material";
import { putData } from "../../BaseUrl";

const TransferDialog = ({ open, onClose, student, sections, onSuccess }) => {
  const [targetSectionId, setTargetSectionId] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const availableSections = sections.filter(
    s => s.id !== student?.currentSectionId && s.enrolledCount < s.maxCapacity
  );

  const handleSubmit = async () => {
    if (!targetSectionId) { setError("Please select a destination section"); return; }
    if (!reason || reason.trim().length < 5) { setError("Please provide a reason (min 5 characters)"); return; }

    setLoading(true);
    setError("");
    try {
      await putData("admin/admission/sections/transfer", {
        applicationId: student.id,
        targetSectionId: parseInt(targetSectionId),
        reason
      });
      const target = sections.find(s => s.id === parseInt(targetSectionId));
      onSuccess(`Student moved from ${student.currentSection} to ${target?.displayName}`);
      resetForm();
    } catch (err) {
      setError(err?.message || "Transfer failed");
    }
    setLoading(false);
  };

  const resetForm = () => { setTargetSectionId(""); setReason(""); setError(""); };

  return (
    <Dialog open={open} onClose={() => { onClose(); resetForm(); }} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>Move Student</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {student?.firstName} {student?.lastName} | Current: {student?.currentSection}
        </Typography>
        <FormControl fullWidth size="small" sx={{ mt: 2, mb: 2 }}>
          <InputLabel>Destination Section *</InputLabel>
          <Select value={targetSectionId} label="Destination Section *"
            onChange={(e) => setTargetSectionId(e.target.value)}>
            {availableSections.map(sec => (
              <MenuItem key={sec.id} value={sec.id}>
                {sec.displayName} ({sec.enrolledCount}/{sec.maxCapacity})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField size="small" fullWidth multiline rows={3} label="Reason for Transfer *"
          value={reason} onChange={(e) => setReason(e.target.value)} />
        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => { onClose(); resetForm(); }} variant="outlined" color="inherit">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)" }}>
          {loading ? "Moving..." : "Confirm Move"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferDialog;
